export function escapeDangerousCSVCharacters(data) {
    if (typeof data === 'string') {
        // Places single quote before the appearance of dangerous characters if they
        // are the first in the data string.
        return data.replace(/^\+|^\-|^\=|^\@/g, "'$&");
    }
    return data;
}

export function findValByKeyInObj (obj, key) {
    var result;

    for (var property in obj) {
        if (obj.hasOwnProperty(property)) {
            if (property === key) {
                return obj[key]; // returns the value
            }
            else if (typeof obj[property] === "object") {
                // in case it is an object
                result = findValByKeyInObj(obj[property], key);

                if (typeof result !== "undefined") {
                    return result;
                }
            }
        }
    }
}

// gets from all the data the selected rows
export const getRowsToBeDownloaded = (selectedRows, displayData) => {
    return displayData.filter(row => selectedRows.data.some(selected => selected.dataIndex === row.dataIndex))
        .map((row) => {
            // to prevent showing objects in csv, we use original rows data
            // instead of data that comes from the main source
            return row.data.map((column,i) => {
                let val = typeof column === 'object' && column !== null && !Array.isArray(column)
                    ? findValByKeyInObj(column,'value') // col value
                    : column;
                val = typeof val === 'function' ? findValByKeyInObj(column,'value') : val;
                return val === null ? "" : val;
            })
        })
}

// this function return the csv string
export const getCsvStringFromArrayOfStrings = (columns, data, separator = ',') => {
    const replaceDoubleQuoteInString = columnData =>
        typeof columnData === 'string' ? columnData.replace(/\"/g, '""') : columnData;

    const buildHead = columns => {
        return (
            columns
                .reduce(
                    (soFar, column) =>
                        column
                            ? soFar +
                            '"' +
                            escapeDangerousCSVCharacters(
                                replaceDoubleQuoteInString(column.label || column.name)) +
                            '"' +
                            separator
                            : soFar,
                    '',
                )
                .slice(0, -1) + '\r\n'
        );
    };
    const CSVHead = buildHead(columns);

    const buildBody = data => {
        if (!data.length) return '';
        return data
            .reduce(
                (soFar, row) =>
                    soFar +
                    '"' +
                    row.map(columnData => escapeDangerousCSVCharacters(
                        replaceDoubleQuoteInString(columnData)))
                        .join('"' + separator + '"') +
                    '"\r\n',
                '',
            )
            .trim();
    };
    const CSVBody = buildBody(data);

    return `${CSVHead}${CSVBody}`.trim();
};

// converts csv string to file
export const saveCsvStringAsFile = (csvString, fileName) => {
    const blob = new Blob([csvString], {type: 'text/csv'});
    const dataURI = `data:text/csv;charset=utf-8,${csvString}`;
    const URL = window.URL || window.webkitURL;
    const downloadURI = typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.setAttribute('href', downloadURI);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const downloadRowsAsCSV = (rows, columns, fileName) => {
    // generate the csv string
    const csvString = getCsvStringFromArrayOfStrings(columns, rows);
    // some disgusting way of downloading the csv but it works i guess
    saveCsvStringAsFile(csvString, fileName);
}
